import { FC } from 'react'
import cn from './index.module.css'
import classNames from 'classnames'

export interface IBasicTextField {
  value: string
  placeholder?: string
  className?: string
  isInvalid?: boolean
  disabled?: boolean
  mark?: string
  type?: 'password' | 'email' | 'tel' | 'number'
  inputMode?:
    | 'email'
    | 'tel'
    | 'search'
    | 'text'
    | 'url'
    | 'decimal'
    | 'none'
    | 'numeric'
  min?: string | number
  max?: string | number
  size?: 'normal' | 'small'
  onChange: (value: string) => void
}

const BasicTextField: FC<IBasicTextField> = ({
  value,
  className,
  placeholder,
  isInvalid,
  disabled,
  type,
  inputMode,
  min,
  max,
  mark,
  size,
  onChange,
}) => {
  const setValue = (e: React.ChangeEvent<HTMLInputElement>) =>
    onChange(e.target.value)

  return (
    <div
      className={classNames(
        cn.wrapper,
        mark && cn.markWrapper,
        size === 'small' && cn.smallSize,
      )}
    >
      <input
        className={classNames(cn.input, isInvalid && cn.invalid, className)}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={setValue}
        disabled={disabled}
        min={min}
        max={max}
        inputMode={inputMode}
      />
      {mark && <div className={cn.mark}>{mark}</div>}
    </div>
  )
}

export default BasicTextField
